import api from './api';

export async function sendEvent(
    {
        analyticsId,
        event,
        studyId,
    }: {
        analyticsId: string;
        event: string;
        studyId: string;
    },
    demoMode: boolean
) {
    if (demoMode) {
        return;
    }
    await api
        .post(`/v2/a/event`, {
            body: JSON.stringify({
                event: event,
                analyticsId: analyticsId,
                studyId: studyId,
            }),
        })
        .catch(err => console.error(`Error: ${err}`));
}
